/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import { formatDate } from "utils";
import SoftBox from "components/SoftBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell/index";
import { InvestmentJointVentureDifferentialAllocationRecordService } from "services/investment-joint-venture-differential-allocation-record";

const renderData = (items, setDataTable) => {
  return items.map((item) => {
    return {
      id: item._id,
      unit: item.unit || "",
      address: item.address || "",
      years: (item.yearsHeader || []).join(", "),
      totalPages: item.totalPages || "1",
      ledgerClerk: item.ledgerClerk || "",
      createdAt: formatDate(item.createdAt),
      action: <ActionCell item={item} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    { Header: "Đơn vị", accessor: "unit", width: "15%" },
    { Header: "Địa chỉ", accessor: "address", width: "20%" },
    { Header: "Năm", accessor: "years", width: "15%" },
    { Header: "Số trang", accessor: "totalPages", width: "10%" },
    { Header: "Người ghi sổ", accessor: "ledgerClerk", width: "15%" },
    { Header: "Ngày tạo", accessor: "createdAt", width: "15%" },
    { Header: "Thao tác", accessor: "action", sorted: false },
  ],
  rows: [],
};

function InvestmentJointVentureDifferentialAllocationRecord() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await InvestmentJointVentureDifferentialAllocationRecordService.getPaginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items, checkCreate: createPerm, paginate } = response.data || response;
      setCheckCreate(createPerm ? false : true);
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Sổ S42a-DN:", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            checkCreate={checkCreate}
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default InvestmentJointVentureDifferentialAllocationRecord;
